import React from 'react';
import './WelcomeScreen.css';
import { useLanguage } from './i18n/LanguageContext';

const WelcomeScreen = ({ onGetStarted }) => {
  const { t } = useLanguage();
  const asset = (file) => `${process.env.PUBLIC_URL || ''}/images/${file}`;

  return (
    <div className="welcome-screen">
      <img
        className="welcome-background-image welcome-background-mobile"
        src={asset('welcome-mobile.png')}
        alt=""
      />
      <img
        className="welcome-background-image welcome-background-tab"
        src={asset('welcome-tab.png')}
        alt=""
      />
      <div className="welcome-gradient-overlay" aria-hidden="true" />

      <div className="welcome-content-card">
        <h1 className="welcome-title">moviq</h1>
        <img className="welcome-wordmark" src={asset('moviq-wordmark.svg')} alt="moviq" />
        <p className="welcome-tagline">{t('Your premium travel experience.')}</p>
        <button type="button" className="get-started-btn" onClick={onGetStarted}>
          <span className="get-started-text">{t('Get started')}</span>
        </button>
      </div>
    </div>
  );
};

export default WelcomeScreen;
